//customize area start
import {
  // Row, Col, Form, Input, Button, Typography,
  Image,
} from "antd";
import Logo from "../../assets/Spectus_new_logo_high_resolution.png";
import LoginStyle from "../login/LoginStyle";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import {
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Button,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import env from "../../config/env";
import CryptoJS from "crypto-js";

//customize area end

const ResetPassword = () => {
  const [userId, setUserId] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const [preventDoubleClick, setPreventDoubleClick] = useState(false);
  const [inputData, setInputData] = useState({
    new_password: "",
    confirm_new_password: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [errorConfirmMessage, setErrorConfirmMessage] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const location = useLocation();
  const Navigate = useNavigate();

  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  useEffect(() => {
    const id = location.state.logindetails;
    setUserId(id);
  });


  const pattern =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,18}$/;

  const onFinish = async () => {
    let newPasswordError = "";
    let confirmPasswordError = "";

    if (inputData.new_password === "") {
      newPasswordError = "Please Input New Password";
    } else if (!pattern.test(inputData.new_password)) {
      newPasswordError =
        "Must contain at least one capital letter and one number and a special character and it has 8 to 18 characters.";
    }

    if (inputData.confirm_new_password === "") {
      confirmPasswordError = "Please input Confirm Password!";
    } else if (inputData.new_password !== inputData.confirm_new_password) {
      confirmPasswordError = "Confirm Password does not match with password!";
    }

    // Set the error messages
    setErrorMessage(newPasswordError);
    setErrorConfirmMessage(confirmPasswordError);

    // If there are no errors, proceed with changing the password
    if (!newPasswordError && !confirmPasswordError) {
      try {
        // const app = { ...user, password: inputData.new_password };
        // await hrmsDataService.updateUser(location.state.logindetails, app);
        // toast.success("Password reset successfully !", {
        //   position: toast.POSITION.TOP_RIGHT,
        //   toastId: "1",
        // });

        try {

          const data = {
            userId: userId,
            newPassword: inputData.new_password,
          }

          // Encrypt data
          const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

          //Encrypt api endpoint
          const updatePassword = CryptoJS.SHA256("/updatePassword" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

          const response = await fetch(
            `${env.backend_api_endpoint}/${updatePassword}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({ encryptedData: encryptedBody }),
            }
          );
          if (!response.ok) {
            const errorData = await response.json();
          }
          if (response.ok) {
            const successData = await response.json();
            if (successData.status === 200) {
              toast.success("Password Changed successfully !", {
                position: toast.POSITION.TOP_RIGHT,
                toastId: "1",
              });

              // Clear input fields and error messages
              setErrorMessage("");
              setErrorConfirmMessage("");
              setInputData({
                new_password: "",
                confirm_new_password: "",
              });
              Navigate("/login");

            }
          }
        } catch (error) {
          console.error("Error Changes Password in:", error.message);
        }
      } catch (error) {
        console.error("Error updating password:", error);
      }
    }
    setPreventDoubleClick(false);
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickConfirmShowPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <LoginStyle>
      <div className="mainLoginDiv">
        <div className="img_div">
          <Image src={Logo} preview={false}></Image>
        </div>
        <div
          className="form_card"
          style={{ height: "auto", minHeight: "550px" }}>
          <h3
            style={{
              fontSize: "36px",
              fontWeight: "600",
              color: "#244DA0",
              fontStyle: "normal",
              textAlign: "left",
              padding: "22px",
              fontFamily: "ImportedMilliardBold",
            }}>
            Reset Password
          </h3>
          <div className="form_item">
            <Typography className="label_form">New Password </Typography>
            <OutlinedInput
              placeholder="New Password"
              value={inputData.new_password}
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end">
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={(e) => {
                setErrorMessage("");
                setInputData({ ...inputData, new_password: e.target.value });
              }}
              size="medium"
              autoComplete="off"
            />
            <FormHelperText id="helper_text">{errorMessage}</FormHelperText>
            <Typography className="label_form" style={{ marginTop: "10px" }}>
              Confirm New Password:{" "}
            </Typography>
            <OutlinedInput
              placeholder="Confirm New Password"
              value={inputData.confirm_new_password}
              type={showConfirmPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickConfirmShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end">
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={(e) => {
                setErrorConfirmMessage("");
                setInputData({
                  ...inputData,
                  confirm_new_password: e.target.value,
                });
              }}
              size="medium"
              autoComplete="off"
            />
            <FormHelperText id="helper_text">
              {errorConfirmMessage}
            </FormHelperText>
            <Button
              variant="contained"
              id="submit_btn"
              onClick={onFinish}
              disabled={preventDoubleClick}
              style={{
                marginTop: "130px",
                background: "#244DA0",
                borderRadius: "6px",
                fontFamily: "ImportedMilliardBold",
                textTransform: "none",
              }}>
              Change Password
            </Button>
          </div>
        </div>
      </div>
    </LoginStyle>
  );
};

export default ResetPassword;
